'use client'

import { MdRefresh } from 'react-icons/md'

import { useAppVersion } from '@/lib/app-version/use-app-version'

/**
 * Tarja de "há versão nova".
 *
 * Na maior parte das vezes ninguém a vê: quando a aba está escondida ou a pessoa
 * não está no meio de nada, o recarregamento acontece sozinho e ela some junto.
 * Ela existe para o caso em que recarregar por cima custaria trabalho — mensagem
 * digitada, formulário preenchido —, e aí quem decide a hora é o usuário.
 *
 * Fica ACIMA do conteúdo e não empurra o layout: as telas têm dezenas de
 * cabeçalhos `sticky top-0` e empurrar tudo por causa de um aviso temporário
 * criaria um problema maior que o que resolve.
 */
export default function AppUpdateBanner() {
    const { updateAvailable, reloadNow } = useAppVersion()

    if (!updateAvailable) return null

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] px-4 w-full max-w-md">
            <div className="alert alert-info shadow-lg flex items-center gap-3 py-3">
                <MdRefresh className="text-xl flex-shrink-0" />
                <span className="text-sm flex-1">
                    Há uma versão nova do sistema. Atualize quando puder.
                </span>
                <button type="button" className="btn btn-sm btn-neutral" onClick={reloadNow}>
                    Atualizar
                </button>
            </div>
        </div>
    )
}
